import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.714 1.143c0 .632-.51 1.143-1.143 1.143h-2.095l-4.76 11.428H8A1.142 1.142 0 1 1 8 16H1.143a1.142 1.142 0 1 1 0-2.286h2.095l4.76-11.428H5.715a1.142 1.142 0 1 1 0-2.286h6.857c.633 0 1.143.511 1.143 1.143" }, null, -1)
  ])))
}
export default { render: render }